// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'degularDisplay', 'degularDisplay Fallback'","fontWeight":800,"fontStyle":"italic"},"className":"__className_85434a","variable":"__variable_85434a"};